import React, { Component } from 'react';
import ajaxCashRound from '../../remote/ajaxCashRound';
import DashTile from '../Common/DashTile';

class TotalGroupBalances extends Component {

    state={
        total:"..."
    }

    componentDidMount() {
        this.getRecord();
    }
    

    getRecord=async()=>{
        const server_response = await ajaxCashRound.totalGroupBalances();
        if(server_response.status=="OK")
        {
            this.setState({
                total:server_response.details.amount_p
            })
        }
    }

    render() {
        return (
            <DashTile 
                title="Total Groups Balance" 
                icon="fe fe-arrow-up" 
                value={this.state.total} 
                percentage="UGX" 
                color="mb-0 text-success fs-13 ml-1" 
                caption="Pending Payout" />
        );
    }
}

export default TotalGroupBalances;